module.exports = __webpack_public_path__ + "static/media/0245_Medium.4fbe75ff.jpg";